import React, { useState, useEffect } from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';
// import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Button, TextField } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { login } from '../../../../api/API';
// const schema = {
//   email: {
//     presence: { allowEmpty: false, message: 'is required' },
//     email: true
//   },
//   password: {
//     presence: { allowEmpty: false, message: 'is required' }
//   }
// };

const useStyles = makeStyles(theme => ({
    root: {},

    fields: {
        margin: theme.spacing(-1),
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            flexGrow: 1,
            margin: theme.spacing(1)
        }

    },

    submitButton: {
        marginTop: theme.spacing(2),
        width: '100%',

        "&:hover": {
            background: "#CECAC1"
        },
    }

}));

export default function From(props) {
    const { className, ...rest } = props;

    const classes = useStyles();
    const history = useHistory();
    // const router = useRouter();
    // const dispatch = useDispatch();

    const [formState, setFormState] = useState({
        // isValid: false,
        values: {},
        touched: {},
        errors: {}
    });

    useEffect(() => {
        // const errors = validate(formState.values, schema);

        setFormState(formState => ({
            ...formState,
            // isValid: errors ? false : true,
            // errors: errors || {}
        }));

    }, [formState.values]);

    const handleChange = event => {
        event.persist();

        setFormState(formState => ({
            ...formState,
            values: {
                ...formState.values,
                [event.target.name]:
                    event.target.type === 'checkbox'
                        ? event.target.checked
                        : event.target.value
            },
            touched: {
                ...formState.touched,
                [event.target.name]: true
            }
        }));
    };

    // const handleSubmit = async event => {
    // event.preventDefault();
    // // dispatch(login());
    // history.push('/dashboard');
    // };

    const handleSubmit = async event => {

        event.preventDefault();

        const postparam = {
            username: formState.values.username,
            password: formState.values.password,
        };
    
        let data = await login(postparam);
        if (data) {
            window.localStorage.setItem("role", data.role);
            window.localStorage.setItem("user_token", data.token);
            switch (data.role) {
                case "admin":
                    window.localStorage.setItem("user_id", data.admin_id);
                    history.push("/appointment");
                    break;
                case "superadmin":
                    window.localStorage.setItem("user_id", data.admin_id);
                    history.push("/appointment");
                    break;
                case "agency":
                    window.localStorage.setItem("user_id", data.agency_id);
                    history.push("/dashboard_agency");
                    break;
                case "agent":
                    window.localStorage.setItem("user_id", data.agent_id);
                    window.localStorage.setItem("agency_id", data.agency_id);
                    history.push("/dashboard_agency");
                    break;
                case "showroom_operator":
                    window.localStorage.setItem("user_id", data.showroom_operator_id);
                    history.push("/appointment");
                    break;
            }

        } else {
            alert('Invalid username or password');
        }
        // });
    };


    return (
        <form
            {...rest}
            className={clsx(classes.root, className)}
            onSubmit={handleSubmit}
        >
            <div className={classes.fields}>
                <TextField
                    fullWidth
                    label="Email"
                    name="username"
                    onChange={handleChange}
                    value={formState.values.username || ''}
                    variant="outlined"
                />
                <TextField
                    fullWidth
                    label="Password"
                    name="password"
                    onChange={handleChange}
                    type="password"
                    value={formState.values.password || ''}
                    variant="outlined"
                />
            </div>
            <Button
                className={classes.submitButton}
                color="secondary"
                size="large"
                type="submit"
                variant="contained"
            >
                Sign in
          </Button>
          <br></br><br></br>
          <hr></hr>
          <br></br>
          Forgot your password ? <Link style={{
              color: "rgb(221 156 20)",
              fontWeight: "bold"
          }} to="/forgotpassword">Click Here</Link>
        </form>
    );
}
